import { useHistory } from 'react-router-dom';
import usePermissions from 'core/hooks/usePermissions';

const useCustomHistory = () => {
  const history = useHistory();
  const { isAdmin, isPartnership, hasTenantId } = usePermissions();

  const normalize = (path) => {
    if (!hasTenantId && isAdmin) {
      return `/a/${path}`;
    }

    if (isPartnership) {
      return `/p/${path}`;
    }

    return `/app/${path}`;
  };

  const push = (path, isContainer = true) => {
    if (isContainer) {
      history.push(normalize(path));
    } else {
      history.push(path);
    }
  };

  return { push };
};

export default useCustomHistory;
